import { Locale } from "../Locale.js";

export const localAliasNameMap: Record<Locale, string> = {
	[Locale.en]: "EN",
	[Locale.cs]: "CZ",
};
